import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    DispatchUpdateAccountSettings,
    ValidateEmail,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import { AccountModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        isSubscribed?: boolean;
        billToId?: string;
        shipToId?: string;
        useDefaultCustomer?: boolean;
        email?: string;
        fulfillmentMethod?: string;
        defaultWarehouse?: WarehouseModel;
        firstName?: string;
        lastName?: string;
    },
    {
        emailErrorMessage?: string;
    }
>;

export const UpdateAccountState: HandlerType = props => {
    const state = props.getState().pages.accountSettings;
    const account = {
        ...state.editingAccount,
    } as AccountModel;
    
    account.firstName = props.parameter?.firstName ?? account.firstName;
    account.lastName = props.parameter?.lastName ?? account.lastName;
    
    props.dispatch({
        ...props.parameter,

        defaultBillToId: state.selectedBillToId,
        defaultShipToId: state.selectedShipToId,
        useDefaultCustomer: state.useDefaultCustomer,
        showSelectDefaultCustomer: state.showSelectDefaultCustomer,
        account,
        type: "Pages/AccountSettings/SetInitialValues",
    });
};

export const chain = [ValidateEmail, DispatchUpdateAccountSettings, UpdateAccountState];

const updateAccountSettings = createHandlerChainRunner(chain, "UpdateAccountSettings");
export default updateAccountSettings;
